import React, { useState } from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Controller, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { SanityTextSlider } from "@graphql-types";
import { Container, StandardLayoutContainer } from "@util/standard";
import { BlocksContent } from "@global";
import { fontSizes, fontWeights, mediaQuery } from "@util/constants";
import { CircleArrow } from "@util/assets";

interface Props {
  data: SanityTextSlider;
}

const TextWrapper = styled(Container)`
  width: 47%;
  h2 {
    font-size: ${fontSizes.h1.default}px;
  }

  ${mediaQuery.largeDown} {
    width: 100%;
    h2 {
      font-size: ${fontSizes.h1.mobile}px;
    }
  }
`;

const BlockTitle = styled.h4`
  font-size: 22px;
  font-weight: ${fontWeights.bold};
  margin: auto;
  text-align: center;
`;

function TextSlider({ data }: Props) {
  if (data == null) return null;
  const [controller, setController] = useState<SwiperCore>();

  const { headerText, blocks } = data;

  const handleSlideChange = (next?: boolean) => {
    if (controller) {
      next ? controller.slideNext() : controller.slidePrev();
    }
  };

  return (
    <>
      <StandardLayoutContainer margin="auto" flexDirection="column">
        <Container justifyContent="space-between" tabletFlexDirection="column">
          {headerText && (
            <TextWrapper>
              <BlocksContent data={headerText} />
            </TextWrapper>
          )}
          <Container justifyContent="flex-end" flexDirection="column" tabletMargin="40px 0 0 0">
            <Container justifyContent="space-between" width="133px" tabletWidth="100%">
              <CircleArrow darkMode onClick={() => handleSlideChange()} />
              <CircleArrow darkMode flip onClick={() => handleSlideChange(true)} />
            </Container>
          </Container>
        </Container>
      </StandardLayoutContainer>

      {blocks && (
        <Container width="90%" margin="100px 0 0 10%" tabletWidth="100%" tabletMargin="50px 0 0 0">
          <Swiper
            modules={[Controller, Pagination, Navigation]}
            onSwiper={setController}
            spaceBetween={16}
            loop
            breakpoints={{
              1000: {
                slidesPerView: 3.8,
              },
              600: {
                slidesPerView: 2.2,
              },
            }}
          >
            {blocks.map((block, index) => {
              if (block == null) return null;
              return (
                <SwiperSlide key={block + index}>
                  <Container
                    width="100%"
                    tabletWidth="95%"
                    mobileWidth="85%"
                    height="234px"
                    margin="0 16px 0 0"
                    tabletMargin="auto"
                    backgroundColor="lightGrey"
                    borderRadius={25}
                  >
                    <BlockTitle>{block}</BlockTitle>
                  </Container>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Container>
      )}
    </>
  );
}

export default TextSlider;
